// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-_9Czl";
var _3 = "summary-vAdJr";
var _4 = "summary_collapsible-3dRQO";
var _5 = "summary__title-336pb";
var _6 = "summary__money-14hck";
var _7 = "summary__arrow-3TA3F";
var _8 = "summary_expand-2ko4h";
var _9 = "details-3UdAr";
var _a = "details__row-3wq4r";
var _b = "details__money-3zV5y";
export { _1 as "__esModule", _2 as "container", _3 as "summary", _4 as "summary_collapsible", _5 as "summary__title", _6 as "summary__money", _7 as "summary__arrow", _8 as "summary_expand", _9 as "details", _a as "details__row", _b as "details__money" }
export default { "__esModule": _1, "container": _2, "summary": _3, "summary_collapsible": _4, "summary__title": _5, "summary__money": _6, "summary__arrow": _7, "summary_expand": _8, "details": _9, "details__row": _a, "details__money": _b }
